<template>
  <!-- 登录后用户模块：头像 + 用户名 + 下拉菜单（个人中心/退出登录）
       视觉与交互规范复用导航栏样式体系（Figma 无登录态设计，按导航栏规范 1:1 推导） -->
  <div class="user-info" @mouseenter="openMenu" @mouseleave="closeMenu">
    <img class="user-info__avatar" :src="avatarUrl" alt="用户头像" />
    <span class="user-info__name">{{ displayName }}</span>
    <transition name="user-menu">
      <ul v-show="menuVisible" class="user-info__menu">
        <li><a href="javascript:void(0);" @click="toUser">个人中心</a></li>
        <li>
          <a href="javascript:void(0);" class="user-info__menu-logout"
            :class="{ 'user-info__menu-logout--loading': loggingOut }" @click="logout">
            {{ loggingOut ? "退出中..." : "退出登录" }}
          </a>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import api from "@/api/index";

export default {
  name: "UserInfo",
  data() {
    return {
      menuVisible: false,
      loggingOut: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userinfo;
    },
    // 展示逻辑沿用现有规则：优先用户名，缺省展示 defaultName（store 中以手机号兜底）
    displayName() {
      return this.userInfo.username || this.userInfo.defaultName;
    },
    // 头像：优先接口返回头像，缺省用站点官方默认头像（与用户中心一致）
    avatarUrl() {
      return this.userInfo.avatar || require("@/assets/images/user/header_icon.png");
    },
  },
  methods: {
    openMenu() {
      this.menuVisible = true;
    },
    closeMenu() {
      this.menuVisible = false;
    },
    toUser() {
      this.menuVisible = false;
      this.$router.push({ name: "user" }).catch(() => {});
    },
    logout() {
      if (this.loggingOut) return;
      this.loggingOut = true;
      api
        .logout()
        .then(() => {
          this.$store.dispatch("clearUserinfo");
          window.location.href = "/";
        })
        .finally(() => {
          this.loggingOut = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$font: "Source Han Sans SC";
$brand: #3461ff;
$text-6: #1d2129;
$text-5: #4e5969;

.user-info {
  display: flex;
  align-items: center;
  position: relative;
  flex-shrink: 0;
  margin-left: 16px;
  height: 40px;
  font-family: $font;
  cursor: pointer;

  &,
  & * {
    box-sizing: border-box;
  }

  /* 悬停桥：覆盖容器与下拉菜单之间的空隙，移入菜单不中断 hover */
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    height: 12px;
  }

  &__avatar {
    flex-shrink: 0;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    object-fit: cover;
  }

  &__name {
    overflow: hidden;
    margin-left: 8px;
    max-width: 96px;
    line-height: 24px;
    letter-spacing: 0;
    color: $text-6;
    font-size: 16px;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color 0.25s ease;
  }

  &:hover &__name {
    color: $brand;
  }

  &__menu {
    position: absolute;
    top: calc(100% + 12px);
    right: 0;
    margin: 0;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 6px 16px rgba(29, 33, 41, 0.12);
    padding: 8px;
    min-width: 96px;
    list-style: none;
    z-index: 21;

    a {
      display: block;
      border-radius: 4px;
      padding: 6px 12px;
      line-height: 22px;
      color: $text-5;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      text-decoration: none;
      white-space: nowrap;
      cursor: pointer;
      transition: background 0.25s ease, color 0.25s ease;

      &:hover {
        background: #f2f3f5;
        color: $brand;
      }
    }
  }

  &__menu-logout--loading {
    opacity: 0.6;
    pointer-events: none;
  }
}

/* 下拉菜单展开/收起过渡（与导航栏动效参数一致：0.25s ease） */
.user-menu-enter-active,
.user-menu-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.user-menu-enter,
.user-menu-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
